function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.337h512v341.326H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#496e2d",
  d: "M0 256h512v170.663H0z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M377.332 199.376c-6.62-18.777-24.511-32.239-45.554-32.239h-41.4c-26.674 0-48.299 21.624-48.299 48.299 0 8.715 2.32 17.091 6.358 24.15-15.373-.126-29.601.106-38.557 0v-47.322l1.902-1.902c8.539-8.539 5.691-22.77 5.691-22.77s-14.229-2.846-22.767 5.693l-9.952 9.952h-11.099c-24.452 0-44.274 19.822-44.274 44.274h32.199v36.224a38.51 38.51 0 002.999 14.943l-11.048 9.207h-16.1v-16.1h-16.1v32.199h72.448v32.199h-16.1v16.1h32.199v-32.199l14.758-17.71h34.883l14.758 17.71v16.1h-16.1v16.1h64.398v-88.548c0-13.338 10.812-24.15 24.15-24.15.343 0 .682.012 1.022.026a32.238 32.238 0 01-1.022-8.076c.001-17.248 13.564-31.327 30.607-32.16zm-86.955 136.808v-33.809h1.342l14.758 17.71v16.1h-16.1v-.001z",
  fill: "#d80027"
});

const SvgWales = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWales, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/wales.bedcaf0e.svg";
export { ForwardRef as ReactComponent };